import type { ReactElement } from 'react';
import AddressModal from 'components/shared/modals/AddressModal';

import type Address from '../../../models/Address';

import useNotifications from '../../../hooks/useNotifications';
import useNextDeliveryDate from '../../../hooks/useNextDeliveryDate';
import { type INotification, NotificationType } from '../../../models/Notifications';
import { get } from '../../../utils/network';
import type { IUpcomingMenu } from '../../../models/UpcomingMenu';
import { ApiRoute } from '../../../config';

type Props = {
  address: Address;
  onUpdate: (address: Address) => void;
};

function AddressCard({ address, onUpdate }: Props): ReactElement {
  const getNextDeliveryDate = useNextDeliveryDate();
  const { dispatch } = useNotifications();

  const closeAddressModal = async (updatedAddress: Address) => {
    if (updatedAddress) {
      const response = await get<IUpcomingMenu[]>(ApiRoute.UPCOMING_MENUS);
      let nextDeliveryDate;
      if (response?.parsedBody) {
        nextDeliveryDate = getNextDeliveryDate(response.parsedBody, updatedAddress.id);
      }

      if (address.primary) {
        dispatch({
          type: 'addNotification',
          notification: {
            id: updatedAddress.id,
            notification_type: NotificationType.ADDRESS_CHANGE,
            operation: 'UPDATE',
            address: updatedAddress,
            date: nextDeliveryDate ?? new Date(),
          } as INotification,
        });
      }
      onUpdate(updatedAddress);
      window.scrollTo({ top: 0, left: 0 });
    }
  };

  return (
    <div
      className={[
        address.isValid ? '' : 'is-invalid',
      ].join(' ')}
    >
      <AddressModal
        isPrimaryEditable={!address.primary}
        isAccountManagementPage
        initialAddress={address}
        onClose={closeAddressModal}
      />
    </div>
  );
}

export default AddressCard;
